<template>
  <popup-modal ref="popup">
    <div>
      <h2 class="font-weight-bold">
        {{ title }}
      </h2>

      <div class="my-8">
        <p>
          {{ message }}
        </p>
        <p v-if="warning" class="warning">
          {{ warning }}
        </p>
      </div>

      <div class="d-flex justify-space-between">
        <v-btn
          class="boom-button-back dialog-button"
          variant="outlined"
          @click="_cancel">
          {{ cancelButton }}
        </v-btn>
        <v-btn
          class="boom-button dialog-button"
          variant="outlined"
          @click="_confirm">
          {{ validateButton }}
        </v-btn>
      </div>
    </div>
  </popup-modal>
</template>

<script>
import PopupModal from './PopupModal.vue'

export default {
  name: 'ConfirmDialogue',
  components: { PopupModal },
  data: () => ({
    title: undefined,
    message: undefined,
    warning: undefined,
    validateButton: undefined,
    cancelButton: undefined,
    resolvePromise: undefined,
    rejectPromise: undefined
  }),
  methods: {
    show(opts = {}) {
      this.title = opts.title
      this.message = opts.message
      this.warning = opts.warning
      this.validateButton = opts.validateButton
      this.cancelButton = opts.cancelButton

      this.$refs.popup.open()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    _confirm() {
      this.$refs.popup.close()
      this.resolvePromise(true)
    },
    _cancel() {
      this.$refs.popup.close()
      this.resolvePromise(false)
    }
  }
}
</script>
<style scoped>
.warning {
  color: var(--error-color);
}

.dialog-button {
  min-width: 100px;
}
</style>
